import { render, staticRenderFns } from "./climate.vue?vue&type=template&id=5a04b827"
import script from "./climate.vue?vue&type=script&lang=ts"
export * from "./climate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports